import { getAbsoluteApiUrl } from "@dashboard/config";

import { SentryAdapter } from "./adapters";
import { ErrorTrackerFactory } from "./trackerFactory";

export const errorTracker = ErrorTrackerFactory(
  SentryAdapter({
    // todo install t3/env
    enabled: process.env.SENTRY_ENABLED === "true",
    dsn: process.env.SENTRY_DSN as string,
    environment: process.env.ENVIRONMENT,
    release: process.env.SENTRY_RELEASE,
    tracesSampleRate: Number(process.env.SENTRY_TRACES_SAMPLE_RATE ?? "0.1"),
    apiUrl: getAbsoluteApiUrl(),
  }),
);
